/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_ArchivedInputs */

const cs_toast_archived = /** @type {(inputs: Toast_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow archivován`)
};

const en_toast_archived = /** @type {(inputs: Toast_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow archived`)
};

/**
* | output |
* | --- |
* | "Workflow archived" |
*
* @param {Toast_ArchivedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const toast_archived = /** @type {((inputs?: Toast_ArchivedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_ArchivedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_archived(inputs)
	return cs_toast_archived(inputs)
});